var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.721 5.70897C38.4545 8.30397 11.586 19.4335 4.162 22.467C-0.816999 24.41 2.0975 26.2315 2.0975 26.2315C2.0975 26.2315 6.3475 27.6885 9.9905 28.7815C13.6335 29.8745 15.5765 28.66 15.5765 28.66L32.6985 17.1235C38.77 12.995 37.313 16.395 35.856 17.852C32.6985 21.0095 27.477 25.988 23.1055 29.9955C21.1625 31.6955 22.134 33.153 22.984 33.8815C26.1415 36.553 34.763 42.0175 35.249 42.382C37.8145 44.198 42.8605 46.8125 43.628 41.289L46.664 22.224C47.6355 15.788 48.607 9.83747 48.7285 8.13747C49.0925 4.00897 44.721 5.70897 44.721 5.70897Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgWhite);
export default __webpack_public_path__ + "static/media/tg-white.37dde31b0846fdee4b7391685eca406d.svg";
export { ForwardRef as ReactComponent };